import { InvoiceType, ChargeCode } from '@xbcb/finance-types';
import { getRecordType } from '@xbcb/core';
import { RecordType, TagKey } from '@xbcb/shared-types';

export const transformInvoiceLines = {
  toSchema: ({ input }: { input: any }) => {
    input.type = InvoiceType.WORK_ORDER_GROUP;
    input.invoiceImmediately = true;
    input.tags = [
      {
        key: 'source',
        value: 'cbmsUi',
      },
    ];
    input.lines = [];
    input.unplannedChargeItems.forEach((chargeItem: any) => {
      if (!chargeItem.posted) {
        if (
          chargeItem.charge === ChargeCode.EXAM_FEE &&
          input.containers?.length >= 1
        ) {
          input.containers.forEach(
            (container: { amount: number; containerNumber: string }) => {
              input.lines.push({
                type: chargeItem.charge,
                amount: {
                  value: container.amount,
                  currency: chargeItem.currency,
                },
                tags: {
                  key: TagKey.CONTAINER_ID,
                  value: container.containerNumber,
                },
              });
            },
          );
        } else {
          input.lines.push({
            type: chargeItem.charge,
            amount: {
              value: chargeItem.amount,
              // TODO Pass currency in chargeItem and use it here
              currency: chargeItem.currency,
            },
          });
        }
      }
    });
    input.documents = [];
    input.documentIdList.forEach((documentId: string) => {
      input.documents.push({
        id: documentId,
      });
    });
    delete input.usConsumptionEntry;
    delete input.unplannedChargeItems;
    delete input.documentIdList;
    delete input.examCharges;
    delete input.containers;
    return input;
  },
  toForm: ({ existingRecords }: { existingRecords: any }) => {
    if (!existingRecords || !existingRecords.length) return;
    const unplannedChargeItems: any[] = [];
    existingRecords?.forEach((record: any) => {
      record.lines?.forEach((line: any) => {
        if (
          getRecordType(line.workOrder.id) ===
            RecordType.US_CONSUMPTION_ENTRY &&
          line.type !== ChargeCode.DISBURSEMENT_FEE
        ) {
          unplannedChargeItems.push({
            charge: line.type,
            amount: line.amount.value,
            posted: true,
          });
        }
      });
    });
    const unplannedChargeForm = {
      unplannedChargeItems,
    };
    return unplannedChargeForm;
  },
};
